import { render, staticRenderFns } from "./SettingsExport.vue?vue&type=template&id=f7b7a60a&"
import script from "./SettingsExport.vue?vue&type=script&lang=js&"
export * from "./SettingsExport.vue?vue&type=script&lang=js&"
import style0 from "./SettingsExport.vue?vue&type=style&index=0&id=f7b7a60a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports